import dashboard from './dashboard';
import consultation from './consultation';
import operations from './operations';
import master from './master';
import cms from './cms';
import delivery from './delivery';
import restaurant from './restaurant';
import roles from './roles';
import users from './users';
import subscriptions from './subscription';
import gym from './gym';

const menuItems = {
  items: [
    dashboard,
    users,
    gym,
    consultation,
    // operations,
    master,
    subscriptions,
    // delivery,
    // restaurant,
    // roles,
    cms
  ]
};

export default menuItems;
